import { render, staticRenderFns } from "./RevenueStatics.vue?vue&type=template&id=7ccd0c60"
import script from "./RevenueStatics.vue?vue&type=script&lang=js"
export * from "./RevenueStatics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports